const organizeArrayToRenderAutomata = (dot) => {
  if (dot) {
    let arrayRender = {
      states: [],
      transitions: [],
    };
    let importantStates = new Array();
    let transitions = new Array();
    let positionsStates = new Array();
    // Pré-processamento
    dot = dot.replace("digraph G {", "");
    dot = dot.replace("}", "");
    dot = dot.replace(/\r/g, "");
    dot = dot.replace(/](?=[^\S\n]*$)/gm, "];\n");
    dot = dot.replace(/^\s*[\r\n]/gm, "");
    const regexcut = /(.+];)(?=\n|$)/g;
    var dotsplitted = dot.match(regexcut);
    for (var k = 0; k < dotsplitted.length; k++) {
      if (dotsplitted[k].includes("pos")) {
        positionsStates.push(dotsplitted[k]);
      } else if (dotsplitted[k].includes("->")) {
        transitions.push(dotsplitted[k]);
      } else if (dotsplitted[k].includes("shape=")) {
        importantStates.push(dotsplitted[k]);
      }
    }
    for (let i = 0; i < positionsStates.length; i++) {
      const stateCurrent = positionsStates[i]
        .split("[")[0]
        .replace(/</gi, "")
        .replace(/>/gi, "");

      const x = positionsStates[i].split('pos="')[1].split(",")[0];
      const y = positionsStates[i]
        .split('pos="')[1]
        .split(",")[1]
        .split('"')[0];
      let state = {
        id: stateCurrent,
        text: stateCurrent,
        x: parseInt(x * 100, 10),
        y: parseInt(y * 100, 10),
      };
      // arrayRender.states[stateCurrent] = state;
      arrayRender.states.push(state);
    }
    for (let i = 0; i < importantStates.length; i++) {
      let state;
      let type;
      if (importantStates[i].includes("[")) {
        state = importantStates[i]
          .split("[")[0]
          .replace(/</gi, "")
          .replace(/>/gi, "");
      }
      if (importantStates[i].includes("shape=")) {
        type = importantStates[i].split("shape=")[1].split("]")[0];
      }
      let index;
      arrayRender.states.forEach((el, id) => {
        if (el.text === state) {
          index = id;
        }
      });
      if (index != -1 && index != undefined) {
        if (type === "Mdiamond") {
          arrayRender.states[index].isInitial = true;
          arrayRender.states[index].isFinal = true;
        } else if (type === "diamond") {
          arrayRender.states[index].isInitial = true;
        } else if (type === "square") {
          arrayRender.states[index].isFinal = true;
        } else {
          arrayRender.states[index].isInitial = false;
          arrayRender.states[index].isFinal = false;
        }
      }
    }

    for (let i = 0; i < transitions.length; i++) {
      let objectDetails = {};
      let initialState;
      let destinyState;
      if (transitions[i].includes("->")) {
        initialState = transitions[i]
          .split("->")[0]
          .replace(/</gi, "")
          .replace(/>/gi, "");
        destinyState = transitions[i]
          .split("->")[1]
          .split("[")[0]
          .replace(/</gi, "")
          .replace(/>/gi, "");
      }
      initialState = arrayRender.states.filter(
        (el) => el.text == initialState
      )[0];
      destinyState = arrayRender.states.filter(
        (el) => el.text == destinyState
      )[0];

      objectDetails.initial = {
        text: initialState.text,
        xPos: initialState.x,
        yPos: initialState.y,
      };
      objectDetails.final = {
        text: destinyState.text,
        xPos: destinyState.x,
        yPos: destinyState.y,
      };
      objectDetails.label = transitions[i].split('"')[1];
      objectDetails.stroke = "black";
      objectDetails.strokeWidth = 1;

      let existsTransition = false;

      for (let i = 0; i < arrayRender.transitions.length; i++) {
        const tran = arrayRender.transitions[i];

        if (
          tran.initial.text == objectDetails.initial.text &&
          tran.final.text == objectDetails.final.text
        ) {
          tran.label += ", " + objectDetails.label;
          existsTransition = true;
        }
      }
      if (existsTransition === false) {
        arrayRender.transitions.push(objectDetails);
      }
    }
    return arrayRender;
  }
};

module.exports = {
  organizeArrayToRenderAutomata,
};
